import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      <div>Created by Owen G</div>
      <div>Not affiliated with HiKiTalo or any other company.</div>
      <div>
        This is a personal project to help me book my sauna slots more easily.
      </div>
    </div>
  );
}
